/*
 * @Author: Zhanglei
 * @Date: 2020-07-08 15:40:07
 * @LastEditTime: 2020-07-29 20:10:13
 * @LastEditors: Zhanglei
 * @Description: In User Settings Edit
 * @FilePath: /desktop/src/main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import store from "./store";
import router from "./router";
import "./router/permission";
import axios from "axios";
import VueResource from "vue-resource";
import ElementUI from "element-ui";
import VueI18n from "vue-i18n";
import message from "./languages/index";
import "element-ui/lib/theme-chalk/index.css";
import "./styles/index.less";
import "../static/css/public.css";
import { messages } from "./utils/resetMessage";
import md5 from "js-md5";
import { getStore } from '@/utils/store'
window.onload = function() {
  document.addEventListener("touchstart", function(event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  });
  document.addEventListener("gesturestart", function(event) {
    event.preventDefault();
  });
};

// 引入ElementUI
// Vue.use(ElementUI)
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});
// md5
Vue.prototype.$md5 = md5;
//  message消息提示
Vue.prototype.$message = messages;
// 引入国际化的包
Vue.use(VueI18n);
let language = getStore({name: 'lang', type: true}) 
if(!language){
  store.getters.getCurrentLanguage;
}
const i18n = new VueI18n({
  locale: !language?store.getters.getCurrentLanguage.value: language.value, // 语言标识,默认汉语,
  messages: message
});

// 阻止 vue 在启动时生成生产提示
Vue.config.productionTip = false;
// 开启debug模式
Vue.config.debug = true;
// 全局初始化 Axios
Vue.prototype.$axios = axios;
// 全局初始化 i18n
Vue.prototype.$i18 = i18n;
// ajax异步
Vue.use(VueResource);
// 交互兼容json对象
Vue.http.options.emulateJSON = true;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  i18n,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js